import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { CONTENT_PLATFORM_PROPERTY_NAME } from 'content-management-data-lib';
// @ts-expect-error Untyped module
import { getDate, getTime } from '../../utils/time';
import CellWithHelpText from './CellWithHelpText';
import { jsx as _jsx } from "react/jsx-runtime";
const SCHEDULED_RESOLVED_STATE = 'SCHEDULED';
const PublishDateCell = ({
  crmObject
}) => {
  let dateString = getPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.PUBLISH_DATE);
  const resolvedState = getPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.RESOLVED_STATE);
  if (!dateString && resolvedState === SCHEDULED_RESOLVED_STATE) {
    dateString = getPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_PUBLISH_DATE);
  }
  if (!dateString) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "content-management-listing-lib.table.cells.emptyValues.date"
    });
  }
  const formattedDate = parseInt(dateString, 10);
  return /*#__PURE__*/_jsx(TFlex, {
    direction: "column",
    children: /*#__PURE__*/_jsx(CellWithHelpText, {
      text: getDate(formattedDate),
      helpText: getTime(formattedDate),
      truncateHelpText: false,
      truncateMainText: true,
      isCell: false
    })
  });
};
export default PublishDateCell;